import { log } from '../../services/utils';

import { noraApiRequest } from '.';

import { controller } from '../../contexts/UIContext';

export const getDocs = async () => {
	log( '* get docs' );
	const { data } = await noraApiRequest( {
		signal: controller.signal,
		url: '/assistant/docs'
	} );

	return data;
};
